/* External */
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

/* Storage */
import { scheduleFetchChannelSchedules } from '../storage/channels';

/* Utils */
import { STATUS_TYPES } from '../utils/constants';
import useCurrentAndNextSchedules from './useCurrentAndNextSchedules';
import useRefSync from './useRefSync';
import useRequestAndDelete from './useRequestAndDelete';

const SCHEDULES_FOR_CHANNEL = 1;

export default function useCurrentSchedule(channel, blackoutNeeded = false, timeToUse = undefined) {
  const currentAndNextSchedules = useCurrentAndNextSchedules(channel, 1, timeToUse);
  const schedule = currentAndNextSchedules?.first();

  const channelId = channel?.channelId;
  const sourceProvider = channel?.sourceProvider;
  const scheduleId = schedule?.normalId;
  const [requestId, setRequestId] = useState(undefined);
  const request = useRequestAndDelete(requestId);
  const timeToUseRef = useRefSync(timeToUse);

  const dispatch = useDispatch();
  useEffect(() => {
    if (channelId && (!scheduleId || blackoutNeeded)) {
      const action = scheduleFetchChannelSchedules({
        channelIdOrIds: channelId,
        sourceProvider,
        schedulesForChannel: SCHEDULES_FOR_CHANNEL,
        fromDatetime: timeToUseRef.current,
      });
      setRequestId(action.requestId);
      dispatch(action);
    }
  }, [
    blackoutNeeded,
    scheduleId,
    timeToUseRef,
    dispatch,
    channelId,
    sourceProvider,
  ]);

  return {
    schedule,
    isCompleted: !!schedule
      || !channelId
      || request?.status === STATUS_TYPES.SUCCEED_STATE
      || request?.status === STATUS_TYPES.FAILED_STATE,
  };
}
